import styled from "styled-components";
import colours from "../../lib/colours";

export const TextInput = styled.input`
  padding: 4px 6px;
  font-size: 16px;
  font-family: "vic";
  color: ${colours.darkerGrey};

  ::placeholder {
    font-style: italic;
  }

  &:disabled {
    cursor: not-allowed;
    color: ${colours.grey1};
  }

  &:invalid {
    border: 2px solid ${colours.error};
  }
`;

export const TextArea = styled.textarea`
  padding: 4px 6px;
  font-size: 16px;
  font-family: "vic";
  color: ${colours.darkerGrey};

  ::placeholder {
    font-style: italic;
  }
`;
